<template>
  <div class="columns is-centered">
    <div class="column is-two-thirds">
      <article class="panel is-primary">
        <p class="panel-heading">
          Paneles Covid-19
        </p>
        <a class="panel-block" v-for="[id, panel] in panels" :key="id" @click="navigateToPanel(id)">
          <b-icon icon="view-dashboard" size="small" />
          {{ panel.title }}
        </a>
      </article>
    </div>
  </div>
</template>

<script>
import rootSchema from '@/schema'

export default {
  name: 'Home',
  computed: {
    panels() {
      return Object.entries(rootSchema.properties)
    }
  },
  methods: {
    navigateToPanel(id) {
      this.$router.push({ name: 'Panel', params: { slug: id } })
    }
  },
  mounted() {
    this.$router.replace({
      name: 'Panel',
      params: {
        slug: Object.keys(rootSchema.properties)[0]
      }
    })
  }
}
</script>

<style scoped>
.panel {
  margin-top: 2vh;
}
</style>
